// import green from '@material-ui/core/colors/green';
import orange from '@material-ui/core/colors/orange';
// import red from '@material-ui/core/colors/red';
import { createTheme } from '@material-ui/core/styles';

const fontFamily = '"IBM Plex Sans", sans-serif';
const typography = {
  fontFamily,
};
const fontColors = {
  black: '#000',
  dark: '#474E57',
  grey: '#8e8e8e',
  disabled: '#929292',
  liveTableLabelColor: 'var(--color-fontColors-liveTableLabelColor)',
};

const fontWeights = {
  normal: 400,
  medium: 500,
  bold: 600,
  extraBold: 700,
};

const backgroundColors = {
  grey: 'var(--color-backgroundColors-grey)',
  disabled: 'var(--color-backgroundColors-disabled)',
  hoverRow: '#f1f1f1',
  hoverRowAlt: '#F7F9FC',
};

const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1100,
    xl: 1920,
  },
};

const colorDefault = {
  light: '#e1e6ed',
  main: '#dae0e9',
  dark: '#989ca3',
  contrastText: fontColors.dark,
};

const colorPrimary = {
  light: '#5076de',
  main: '#2554d6',
  dark: '#193a95',
  mainAlt: '#2A55D5',
};

const colorDanger = {
  light: '#f97b85',
  main: '#f85b67',
  dark: '#ad3f48',
};

const colorSafe = {
  light: '#4ebf7f',
  main: '#22af60',
  dark: '#177a43',
  contrastText: '#fff',
};

const colorsForValues = {
  green: 'var(--color-colorsForValuesGreen)',
  red: 'var(--color-colorsForValuesRed)',
};

const targetPanelColors = {
  stopLoss: '#D0021B',
  target: '#30ad67',
  trailingStoploss: '#E78400',
  waitAndTrade: 'var(--color-targetPanelColors-waitAndTrade)',
  rangeBreakout: 'var(--color-targetPanelColors-rangeBreakout)',
};

const themeDefault = createTheme({
  typography,
  palette: {
    primary: colorDefault,
  },
  breakpoints,
});

const themeWhite = createTheme({
  typography,
  palette: {
    primary: {
      light: '#fff',
      main: '#fff',
      dark: '#b2b2b2',
    },
  },
  breakpoints,
});

const themePrimary = createTheme({
  typography,
  palette: {
    primary: colorPrimary,
  },
  breakpoints,
});

const themeSafe = createTheme({
  typography,
  palette: {
    primary: colorSafe,
  },
  breakpoints,
});

const themeWarning = createTheme({
  typography,
  palette: {
    primary: {
      light: orange[300],
      main: orange[500],
      dark: orange[700],
      contrastText: '#fff',
    },
  },
  breakpoints,
});

const themeDanger = createTheme({
  typography,
  palette: {
    primary: colorDanger,
  },
  breakpoints,
});

export {
  colorDefault,
  colorPrimary,
  colorSafe,
  colorDanger,
  themeDefault,
  themeWhite,
  themePrimary,
  themeSafe,
  themeWarning,
  themeDanger,
  fontColors,
  backgroundColors,
  fontWeights,
  targetPanelColors,
  colorsForValues,
};
